// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","276":"GuestLazyComponent"}[chunkId] + "." + {"46":"fcfdc0296e5bf86caef0","276":"40f08c533cb2cb3b4400"}[chunkId] + ".js";
};